<template>
  <div
    v-if="basisPaybackFeature"
    class="c-vendor-payback-teaser-scoreboard text-payback flex flex-col gap-5 relative bg-payback-light rounded-3xl punkti-puh shadow-lg font-Payback lg:items-center cursor-pointer"
    @click="handleReroute()"
  >
    <div class="w-1/2 lg:w-full flex lg:gap-4 py-4 lg:py-0 flex-col lg:flex-row lg:justify-between">
      <div class="flex items-center px-4 lg:p-8"><VendorPaybackLogo class="h-[40px]" /></div>
      <div class="hidden lg:flex items-end">
        <nuxt-img
          densities="x1"
          loading="lazy"
          class="max-w-36"
          provider="cloudflare"
          :src="'/05/ea/2e/60048339d869e317aef761e3b2691fd060/Pointees_Desktop_Links.png'"
          :alt="'PAYBACK'"
        />
      </div>
      <template v-if="loggedIn && user?.userInfo?.payback_integration == 'enabled' && fullPaybackFeature">
        <VendorPaybackErrorBoundary>
          <VendorPaybackTeaserScoreboardBalanceList />
        </VendorPaybackErrorBoundary>
      </template>
      <template v-else>
        <div class="text-xl lg:text-[26px] lg:whitespace-nowrap font-extrabold p-4 flex items-center">
          Jetzt PAYBACK Vorteile bei expert nutzen!
        </div>
      </template>
      <div class="hidden lg:flex items-end">
        <nuxt-img
          densities="x1"
          loading="lazy"
          class="max-w-[360px]"
          provider="cloudflare"
          :src="'/8c/03/96/eea8b261a1096169e46100646a435f4845/Pointee_Desktop_Rechts.png'"
          :alt="'PAYBACK'"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const { loggedIn, user } = useOidcAuth();

const featureStatePayback = computed(() => useFeatureState('exsi-1556') && useCurrentStore().value.paybackStore);
const basisPaybackFeature = computed(
  () =>
    featureStatePayback.value
    && (useFeatureValue('exsi-1556').value?.name == 'basic'
      || useFeatureValue('exsi-1556').value?.name == 'redemption'
      || useFeatureValue('exsi-1556').value?.name == 'full')
);
const fullPaybackFeature = computed(() => (featureStatePayback.value && useFeatureValue('exsi-1556').value?.name == 'full'));

function handleReroute() {
  navigateTo('/shop/payback');
}
</script>
<style lang="postcss" scoped>
.punkti-puh {
  @apply bg-right-bottom lg:!bg-none bg-no-repeat;
  background-size: 50%;
  background-image: url('https://cdn.expert.de/14/4b/70/e3a281c6f6b2b09d2d4027447d01b6d345/Pointees_Mobile.png');
}
</style>
